import React from 'react';
import Span from '../../../../../common/text/Span';

/**
 *  타금융 할부목록 아이템 로우 컴포넌트
 * @param {boolean} openCm cm 펼치기 여부
 * @param {string} device pr or mobile
 *  */
function OtherBankItemDummyRow({
  openCm,
  device,
}: {
  openCm: boolean;
  device: string;
}): JSX.Element {
  return (
    <tr>
      <td>
        <Span>-</Span>
      </td>
      <td>
        <Span>-</Span>
      </td>
      <td>
        <Span>-</Span>
      </td>
      <td>
        <Span>-</Span>
      </td>
      {device === 'pc' && (
        <>
          <td>
            <Span>-</Span>
          </td>
          <td>
            <Span>-</Span>
          </td>
        </>
      )}
      {openCm && (
        <td>
          <Span>-</Span>
        </td>
      )}
    </tr>
  );
}

export default OtherBankItemDummyRow;
